import { objectToQueryParams } from 'src/utils';

import messages from './messages';

const PRODUCT_STATUS_COMPLETED = 'Design Complete';
const PRODUCT_STATUS_PENDING = 'Design Pending';

const getProductListConfig = (payload) => {
  const url = '/mcp/custom-designs';
  const {
    pagination,
    customProductCategory,
    productCategoryFormat
  } = payload || {};

  const paginationConfig = pagination ? {
    pageNumber: pagination?.currentPage,
    pageSize: pagination?.pageInterval
  } : {};

  const queryParams = objectToQueryParams({
    ...paginationConfig, customProductCategory, productCategoryFormat
  });

  return {
    url: `${url}${queryParams}`,
    dataPath: ['customDesigns'],
  };
};

const getProductStatusMessage = (status) => {
  if (status === PRODUCT_STATUS_COMPLETED) {
    return messages.productCompleted;
  }

  return messages.productPending;
};

export default class Product {
  static NAME = 'custom_design';

  static STATUS_COMPLETED = PRODUCT_STATUS_COMPLETED;

  static STATUS_PENDING = PRODUCT_STATUS_PENDING;

  static getListConfig = getProductListConfig;

  static getDeleteConfig = () => ({ url: '/mcp/custom-designs/delete' });

  static getStatusMessage = getProductStatusMessage;

  constructor(product) {
    this.id = product.workspaceId;
    this.name = product.name;
    this.description = product.description;
    this.type = product.itemType;
    this.status = product.status;
    this.lastModified = product.lastModified;
    this.detailsLink = product.productLink;
    this.canExport = product.canExportDesign;
  }

  getDetailsLink() {
    return '';
  }
}
